import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import introImg from '../assets/newHeader/healthcare1.png';
import { ReactComponent as SurfaceIcon } from '../assets/newHeader/healthcare1.svg';
import { ReactComponent as MatchIcon } from '../assets/newHeader/healthcare2.svg';
import { ReactComponent as PlaceIcon } from '../assets/newHeader/healthcare3.svg';
import { ReactComponent as NewPlaceIcon } from '../assets/newHeader/healthcare4.svg';
import image1 from '../assets/newHeader/healthcare5.png';
import image2 from '../assets/newHeader/healthcare6.png';
import image3 from '../assets/newHeader/healthcare7.jpeg';
import education1 from '../assets/public-site/education1.svg';
import hiringSvg from '../assets/public-site/healthcare0.svg';
import image16 from '../assets/public-site/img16.jpeg';
import provenHealthcare from '../assets/public-site/provenHealthcare.png';
import surfaceImage1 from '../assets/public-site/surfaceImage1.png';
import hrTool from '../assets/public-site/svg14.svg';
import workForce from '../assets/public-site/workForce.png';
import workImage from '../assets/public-site/workImage.png';
import { FeatureCard } from '../components/common/FeatureCard';
import { TestimonialCarousel } from '../components/common/TestimonialCarousel';
// import { InfoCard } from '../components/common/InfoCard';
// eslint-disable-next-line import/order
import { ExportedIcon } from '../components/icons/icons';
import { NewFooter } from '../components/Layout/NewFooter';
import { NewNavbar } from '../components/Layout/NewHeader';

import { ConnectForm } from './ConnectUseForm';

export const HealthCarePage: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const features = [
    {
      image: image1,
      title: 'Find fit faster',
      description:
        'Instantly match untapped candidates based on the traits of your top performers.',
    },
    {
      image: image2,
      title: 'Streamline placements',
      description:
        'Automate caregiver matching based on diagnosis, client needs, and preference data — not just availability.',
    },
    {
      image: image3,
      title: 'Retain what works',
      description:
        'Predict long-term performance and reduce early churn by aligning new hires with care delivery goals.',
    },
  ];
  const testimonialData = [
    {
      name: 'Edwin Rivera',
      location: 'Managing Partner,CG1 Solutions',
      title: 'Faster Hires, Better Matches',
      text: 'Hiring the wrong caregiver doesn’t just cost money - it breaks trust with patients and families. Vero helps us get it right, every time.',
      image: image16,
      collanColor: 'text-[#4A5FF7]',
    },
    {
      name: 'Edwin Rivera 2',
      location: 'Edwin Rivera, 24/7 Nursing Care',
      title: 'Faster Hires, Better Matches',
      text: 'Vero helped us reduce time-to-hire by over 60% while improving placement fit. Their team gets it.',
      image: image16,
    },
  ];

  return (
    <div>
      <NewNavbar />
      {/* container 1 */}
      <div className="relative w-full h-screen overflow-hidden">
        {/* Background image */}
        <img
          src={introImg}
          alt=""
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-30 z-10"></div>

        {/* Content at the bottom center */}
      </div>

      {/* Hiring Section */}
      <section className="py-16">
        <div className="container px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mt-12">
            {/* Left Content */}
            <div className="mx-auto md:mt-10 items-center gap-10">
              {/* Left Column - Text */}
              <div className="text-center lg:text-left space-y-6">
                <div className="py-7">
                  <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light lg:!leading-[75px] mb-5">
                    Surface overlooked talent. Predict job success.
                    <span className="font-bold text-primary-500"> Transform patient outcomes.</span>
                  </h2>
                  <p className="text-black font-normal text-xl leading-[36px]">
                    Hiring in healthcare isn’t just about coverage—it’s about care continuity,
                    performance, and trust. Vero Learning helps providers screen smarter, place
                    faster, and retain longer in high-turnover frontline roles, from CNAs to home
                    health aides and behavioral health staff.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Image */}
            <div className="relative w-full flex items-end justify-center">
              <img
                src={surfaceImage1}
                alt="Surface Image"
                className="w-full 2xl:w-3/4 h-auto object-contain rounded-xl"
              />
            </div>
          </div>
          <div className="pt-10 text-center lg:text-left">
            <h2 className="font-bold text-3xl leading-[54px] align-middle text-center lg:text-left mb-3">
              Vero’s matching improves with every placement, using real-time feedback to get smarter
              over time.
            </h2>
            <a
              href="https://meetings.hubspot.com/chrissybil/vero-learning"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-secondary !px-12 !py-6 hover:underline !whitespace-normal"
            >
              Schedule a Demo
              <ExportedIcon />
            </a>
          </div>
        </div>
      </section>
      {/* Frontline Section */}
      <section className="py-16 bg-primary-200">
        <div className="container">
          <div className="text-center gap-6">
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light lg:!leading-[75px] mb-5">
              Frontline care is too critical to
              <span className="font-bold text-primary-500"> leave to guesswork.</span>
            </h2>
            <div>
              <p className="text-xl text-center leading-[36px]">
                Turnover rates for frontline healthcare roles are topping 45%. Staffing shortages
                are the norm, not the exception. And traditional tools can't keep up. Vero surfaces
                untapped talent and predicts placement success—so you can fill roles faster, retain
                caregivers longer, and keep care delivery on track.
              </p>
              <a
                href="https://meetings.hubspot.com/chrissybil/vero-learning"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-secondary !px-12 !py-6 hover:underline !whitespace-normal mt-6"
              >
                See how Vero works
                <ExportedIcon />
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* The Workforce Crisis  Section */}
      <section className="pb-0 pt-8">
        <div className="container px-4">
          <div className="grid grid-cols-1 lg:grid-cols-[35%_65%] gap-10 items-center mt-12">
            {/* Left Image */}
            <div className="relative w-full flex items-center justify-center">
              <img
                src={workForce}
                alt="build Retail"
                className="w-full 2xl:w-3/4 h-auto object-contain rounded-xl"
              />
            </div>
            {/* Right Content */}
            <div className="mx-auto md:mt-10 items-center gap-10">
              {/* Right Column - Text */}
              <div className="mx-auto text-center lg:text-left">
                <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-tight lg:!leading-[75px] mb-5">
                  The Workforce
                  <span className="font-bold text-primary-500"> Crisis Is Here</span>
                </h2>
              </div>
              <div className="text-center md:text-left space-y-6">
                {[
                  {
                    desc: [
                      'Hiring in healthcare isn’t just about headcount—it’s about safety, satisfaction, and retention. Misplaced or mismatched staff lead to:',
                    ],
                    list: [
                      'Increased patient complaints and fall risk',
                      'Missed care hours and emergency backfills',
                      'Burnout and cascading turnover',
                      'CMS penalties and reputational damage',
                    ],
                  },
                ].map((item, index) => (
                  <div key={index} className="">
                    <p className="text-black text-xl leading-tight lg:leading-[41px]">
                      {item.desc}
                    </p>
                    {item.list && (
                      <ul className="text-black mt-4 text-xl list-disc list-outside font-normal leading-loose pl-5 text-left">
                        {item.list.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
              <div className="py-3">
                <p className="text-black font-normal text-xl leading-[40px]">
                  That’s why Vero helps you staff smarter—before these costs hit your bottom line
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-col lg:flex-row items-center justify-between gap-4 py-10">
            <h2 className="font-bold text-3xl leading-[54px] align-middle text-center lg:text-left">
              Built for multi-site hiring - from flagship stores to remote locations.
            </h2>
            <a
              href="https://meetings.hubspot.com/chrissybil/vero-learning"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-secondary !px-12 !py-6 hover:underline !whitespace-normal"
            >
              Book a strategy session
              <ExportedIcon />
            </a>
          </div>
        </div>
      </section>
      {/* Traditional Hiring Section*/}
      <section className="py-16 pt-0">
        <div className="container px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mt-12">
            {/* Left Content */}
            <div className="mx-auto md:mt-10 items-center gap-10">
              {/* Left Column - Text */}
              <div className="mx-auto">
                <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-tight lg:!leading-[75px] mb-5 text-center lg:text-left">
                  Where Traditional Hiring
                  <span className="font-bold text-primary-500"> Falls Short</span>
                </h2>
              </div>
              <div className=" pb-7 pt-4">
                <p className="text-black font-normal text-xl leading-[40px] text-center lg:text-left">
                  Most tools focus on availability or credentialing, not long-term performance. That
                  leads to:
                </p>
              </div>
              <div className="text-center md:text-left space-y-2">
                {[
                  {
                    list: [
                      'High no-show and turnover rates',
                      'Fragmented staffing coordination',
                      'Constant retraining',
                      'Poor match between client needs and candidate personality or experience',
                    ],
                  },
                ].map((item, index) => (
                  <div key={index} className="rounded-[32px] p-7 bg-green-200">
                    {item.list && (
                      <ul className="text-black  text-xl list-disc list-outside font-medium leading-loose  pl-5 text-left">
                        {item.list.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Right Image */}
            <div className="relative w-full flex items-center justify-center">
              <img
                src={hiringSvg}
                alt="stack Image"
                className="w-full 2xl:w-3/4 h-auto object-contain rounded-xl"
              />
            </div>
          </div>
          <div className="py-7 mx-auto">
            <p className="text-black font-normal text-xl leading-[40px] text-center lg:text-left">
              Whether you’re hiring bilingual aides, post-acute caregivers, or behavioral health
              staff Vero adapts to your placements, not just job titles.
            </p>
          </div>
        </div>
        <div className="container flex flex-col lg:flex-row items-center justify-between gap-4 py-10">
          <h2 className="font-bold text-3xl leading-[54px] align-middle text-center lg:text-left">
            Ready to reduce retraining and no-shows?
          </h2>

          <a
            href="https://meetings.hubspot.com/chrissybil/vero-learning"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-secondary !px-12 !py-6 hover:underline !whitespace-normal"
          >
            Start your pilot <ExportedIcon />
          </a>
        </div>
      </section>
      <section className="">
        <div className="container">
          <div className="text-center mb-10">
            <h2 className="text-3xl sm:text-4xl md:text-6xl !leading-snug mb-6">
              Vero helps
              <span className="text-primary-500 font-bold"> your team</span>
            </h2>
          </div>
          <div className="w-full flex justify-center">
            <div className="px-4 w-full space-y-6">
              {/* First row - 3 cards */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 place-items-stretch">
                {features.slice(0, 3).map((feature, index) => (
                  <FeatureCard
                    key={index}
                    image={feature.image}
                    title={feature.title}
                    description={feature.description}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="w-full text-center">
            <p className="text-2xl font-normal leading-snug lg:!leading-[36px] mt-6">
              Vero isn’t a dashboard. It’s predictive infrastructure embedded into daily
              workflows—helping schedulers and care teams make better hiring decisions, faster.
            </p>
          </div>
        </div>
      </section>
      <section className="py-16">
        <div className="container">
          <div className="text-center mb-10">
            <h2 className="text-3xl sm:text-4xl md:text-6xl !leading-snug mb-3">
              Here’s how it
              <span className="text-primary-500 font-bold"> works</span>
            </h2>
            <p className="text-xl font-normal !leading-relaxed">
              Whether you're hiring bilingual aides, post -acute caregivers or behavioral health
              staff, Vero adapts to your placement, not just job titles.
            </p>
          </div>
          {/* Cards */}
          <div className="mt-12 grid grid-cols-1  lg:grid-cols-2 xl:grid-cols-4 gap-12 mx-auto relative z-10">
            {/* Step 1 */}
            <div className="relative z-10 bg-[#E6E8FE] rounded-[20px]  border-[#4763ff] p-6 flex flex-col items-center text-center shadow hover:shadow-md transition-all">
              <SurfaceIcon className=" mb-4" />
              <h3 className="text-xl font-semibold mb-2">Profile what success looks like</h3>
              <p className="text-base leading-tight text-gray-600">
                Vero adapts to your care environment - learning from team performance and real-world
                outcomes to improve every match.
              </p>
            </div>

            {/* Step 2 */}
            <div className="relative z-10 bg-[#F4FFDD] rounded-[20px] p-6 flex flex-col items-center text-center shadow hover:shadow-md transition-all">
              <MatchIcon className=" mb-4" />
              <h3 className="text-xl font-semibold mb-2">Score untapped candidates</h3>
              <p className="text-base leading-tight text-gray-600">
                Upload candidates or pull from your system — Vero flags gaps, ranks retention risk,
                and predicts job fit.
              </p>
            </div>

            {/* Step 3 */}
            <div className="relative z-10 bg-[#F5F3EB] rounded-[20px] p-6 flex flex-col items-center text-center shadow hover:shadow-md transition-all">
              <PlaceIcon className=" mb-4" />
              <h3 className="text-xl font-semibold mb-2">Match to the right placements</h3>
              <p className="text-base leading-tight text-gray-600">
                Align candidates by case type, personality fit, and caregiver-client dynamics.
              </p>
            </div>
            {/* Step 4 */}
            <div className="relative z-10 bg-[#FEF7DF] rounded-[20px] p-6 flex flex-col items-center text-center shadow hover:shadow-md transition-all">
              <NewPlaceIcon className=" mb-4" />
              <h3 className="text-xl font-semibold mb-2">Get feedback, refine, repeat</h3>
              <p className="text-base leading-tight text-gray-600">
                Vero’s AI improves the more you use it — every placement strengthens the model.
              </p>
            </div>
          </div>
          <div className="container flex flex-col items-center justify-between gap-4 py-10">
            <h2 className="font-bold text-3xl leading-[54px] align-middle text-center lg:text-left">
              Built for scale. Designed for privacy. Ready to integrate.
            </h2>

            <a
              href="https://meetings.hubspot.com/chrissybil/vero-learning"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-secondary !px-12 !py-6 hover:underline !whitespace-normal"
            >
              See Vero In Action
              <ExportedIcon />
            </a>
          </div>
        </div>
      </section>
      {/* Retain What Works Section*/}
      <section className="py-16 pt-0">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-normal leading-tight lg:!leading-[75px] mb-5">
            Retain What Works
            <span className="font-bold text-primary-500"> </span>
          </h2>
        </div>
        <div className="container px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mt-6">
            <div className="order-2 lg:order-1 mx-auto items-center gap-10">
              <div className="pb-7 pt-4">
                <p className="text-black font-normal text-xl leading-[40px] text-center lg:text-left">
                  It costs up to $60,000 to replace one direct care worker. With Vero, you can stop
                  reacting to turnover—and start building a reliable, loyal workforce.
                </p>
              </div>
              <div className="text-center md:text-left space-y-6">
                {[
                  {
                    desc: ['We help you:'],
                    list: [
                      'Spot your highest-potential staff early',
                      'Connect them to coaching and internal mobility tracks',
                      'Reduce burnout by aligning people to the right type of care work',
                      'Keep institutional knowledge in-house',
                    ],
                  },
                ].map((item, index) => (
                  <div
                    key={index}
                    className="border-dashed border border-purple-200 rounded-[32px] p-7"
                  >
                    <p className="text-black text-xl font-normal leading-loose text-left">
                      {item.desc}
                    </p>
                    {item.list && (
                      <ul className="text-black text-xl list-disc list-outside font-medium leading-loose pl-5 text-left">
                        {item.list.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
              <div className="flex justify-center lg:justify-start mt-3">
                <a
                  className="mt-6 btn btn-secondary !whitespace-normal !py-6 !px-8"
                  href="https://meetings.hubspot.com/chrissybil/vero-learning"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Support internal career growth <ExportedIcon />
                </a>
              </div>
            </div>
            <div className="order-1 lg:order-2 relative w-full flex items-center justify-center">
              <img
                src={workImage}
                alt="stack Image"
                className="w-full 2xl:w-3/4 h-auto object-contain rounded-xl"
              />
            </div>
          </div>
        </div>
      </section>
      {/* Proven Impact Section */}
      <section className="pt-16 bg-primary-200">
        <div className="container">
          <h2 className="text-5xl text-center">
            Proven <span className="text-primary-500 font-bold">Impact.</span>
          </h2>
          <TestimonialCarousel testimonials={testimonialData} />
        </div>
      </section>
      {/* Proven impact in healthcare  Section */}
      <section className="pb-16">
        <div className="container px-4">
          <div className="grid grid-cols-1 lg:grid-cols-[35%_65%] gap-10 items-center mt-12">
            {/* Left Image */}
            <div className="relative w-full flex items-center justify-center">
              <img
                src={provenHealthcare}
                alt="build Retail"
                className="w-full 2xl:w-3/4 h-auto object-contain rounded-xl"
              />
            </div>
            {/* Right Content */}
            <div className="md:mt-10 items-center gap-10">
              {/* Right Column - Text */}
              <div className="mx-auto text-center lg:text-left">
                <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-tight lg:!leading-[75px] mb-5">
                  Proven impact in
                  <span className="font-bold text-primary-500 lg:block"> healthcare</span>
                </h2>
              </div>
              <div className="text-center md:text-left space-y-6">
                {[
                  {
                    list: [
                      'Up to 60% reduction in time-to-hire',
                      'Improved client satisfaction through smarter caregiver matching',
                      'Better retention insights to prevent churn before it starts',
                      '87%+ completion rates across 35,000+ users',
                    ],
                  },
                ].map((item, index) => (
                  <div key={index} className="mt-8">
                    {item.list && (
                      <ul className="text-black mt-4 text-xl list-disc list-outside font-normal leading-loose  pl-5 text-left">
                        {item.list.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
              <div className="flex flex-col lg:flex-row items-center justify-between gap-4 py-10">
                <a
                  href="https://meetings.hubspot.com/chrissybil/vero-learning"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-secondary !px-12 !py-6 hover:underline !whitespace-normal"
                >
                  Let’s Talk
                  <ExportedIcon />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* AI That Learns From You  Section */}
      <section className="pb-16">
        <div className="container px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mt-6">
            {/* Left Image */}
            <div className="relative w-full flex items-center justify-center">
              <img
                src={education1}
                alt="build Retail"
                className="w-full 2xl:w-3/4 h-auto object-contain rounded-xl"
              />
            </div>
            {/* Right Content */}
            <div className="md:mt-10 items-center gap-10">
              {/* Right Column - Text */}
              <div className="mx-auto text-center lg:text-left">
                <h2 className="text-5xl md:text-6xl font-normal leading-tight lg:!leading-[56px] mb-5">
                  AI That Learns
                  <span className="font-bold text-primary-500 lg:block"> From You</span>
                </h2>
              </div>
              <div className="text-center md:text-left space-y-6">
                {[
                  {
                    list: [
                      'Caregiver performance reviews',
                      'Patient feedback and care plan success',
                      'Retention data and shift preferences',
                      'Notes from care coordinators and recruiters',
                    ],
                  },
                ].map((item, index) => (
                  <div key={index} className="mt-8">
                    {item.list && (
                      <ul className="text-black mt-4 text-xl list-disc list-outside font-normal leading-loose pl-5 text-left">
                        {item.list.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
              <div className="py-3">
                <p className="text-black font-normal text-xl leading-[40px] text-center lg:text-left">
                  Each insight powers the next great match. That’s why our clients say: “Before
                  Vero, we were guessing. Now we know who’s ready to grow—and where they’ll thrive.”
                </p>
              </div>
              <div className="flex flex-col lg:flex-row items-center justify-between gap-4 py-10">
                <a
                  href="/login"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-secondary !px-12 !py-6 hover:underline !whitespace-normal"
                >
                  Start Now
                  <ExportedIcon />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* HR tool Section*/}
      <section className="py-16 pt-0">
        <div className="container px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mt-12">
            {/* Left Content */}
            <div className="mx-auto md:mt-10 items-center gap-10">
              {/* Left Column - Text */}
              <div className="mx-auto">
                <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-tight lg:!leading-[75px] mb-5">
                  This isn’t another HR tool.
                  <span className="font-bold text-primary-500"> It’s your competitive edge.</span>
                </h2>
              </div>
              <div className="pb-7 pt-4">
                <p className="text-black font-normal text-xl leading-[40px] mb-4 text-center lg:text-left">
                  Healthcare moves fast. Vero helps you move smarter - automating what slows you
                  down, and surfacing what matters most.
                </p>
                <p className="text-black font-normal text-xl leading-[40px] text-center lg:text-left">
                  Our tools are lightweight, secure, and designed for operators. We work directly
                  with your HR, clinical, and scheduling teams to train the model on your success
                  signals—not generic benchmarks.
                </p>
              </div>
            </div>
            {/* Right Image */}
            <div className="relative w-full flex items-center justify-center">
              <img
                src={hrTool}
                alt="stack Image"
                className="w-full 2xl:w-3/4 h-auto object-contain rounded-xl"
              />
            </div>
          </div>
        </div>
      </section>
      <ConnectForm
        header="Let’s talk about how Vero can streamline your healthcare hiring."
        text=""
        buttonText="Book time here"
        actionButtonText="See Vero in action"
      />
      <NewFooter />
    </div>
  );
};
